import type { OriginalSize } from '@shared/lib/types/do';
import type { OriginalSizeSingle } from '@shared/ui/list/types';

export const getProductWrapperMaxWidthBasedOnArtworkHeight = (
  originalSize: OriginalSize,
  isClassName = false,
  vhInitialSize = 100,
): string => {
  const minVh = 40;
  const maxVh = 300;

  const ratio = originalSize.w / originalSize.h;
  // const vhInitialSize = 100;
  const headerApproxSizeVh = 15;
  let countedVhWidth = Math.round((ratio * vhInitialSize - headerApproxSizeVh) / 2) * 2;

  if (minVh > countedVhWidth) countedVhWidth = minVh;
  if (maxVh < countedVhWidth) countedVhWidth = maxVh;

  return isClassName ? `max-w-vh-${countedVhWidth}` : `${countedVhWidth}vh`;
};

const ARTWORK_SIZE_DEFAULT_VALUE = 40;

export const mapOriginalSize = (originalSizeX: OriginalSizeSingle, originalSizeY: OriginalSizeSingle): OriginalSize => {
  const numX = +(originalSizeX || 0);
  const numY = +(originalSizeY || 0);
  if (numX && numY) {
    return {
      w: numX,
      h: numY,
    };
  }
  return {
    w: ARTWORK_SIZE_DEFAULT_VALUE, // some default vals
    h: ARTWORK_SIZE_DEFAULT_VALUE, // some default vals
  };
};

type ExpectedPrice = string | number | null;

export const formatPriceUsd = (value: ExpectedPrice): string => {
  if (!value) {
    return '';
  }
  return `$${(+value)?.toFixed(0)}`;
};
export const formatPriceEth = (value: ExpectedPrice): string => {
  if (!value) {
    return '';
  }
  return `${(+value)?.toFixed(1)}ETH`;
};
